import axios from 'axios';

let refreshPromise = null;

export function getAccessToken() {
  return localStorage.getItem('ecmtctoken');
}

export function getRefreshToken() {
  return localStorage.getItem('ecmtcrefresh');
}

export function saveTokens(authorization, refreshToken) {
  if (authorization) {
    localStorage.setItem('ecmtctoken', authorization);
  }
  if (refreshToken) {
    localStorage.setItem('ecmtcrefresh', refreshToken);
  }
}

export function clearRefreshToken() {
  localStorage.removeItem('ecmtcrefresh');
}

export async function refreshAccessToken() {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    return false;
  }

  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = (async () => {
    try {
      const headers = { 'Content-Type': 'application/json' };
      const accessToken = getAccessToken();
      if (accessToken) {
        headers['ECAPP-TWXHEADER'] = accessToken;
      }

      const response = await axios.post(
        `${process.env.VUE_APP_BASE_API}eclrefresh`,
        { refreshToken },
        { headers }
      );

      const data = response.data;
      if (data && data.success === true && data.authorization) {
        saveTokens(data.authorization, data.refreshToken);
        return true;
      }
      return false;
    } catch (err) {
      return false;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
}

export async function retryRequestAfterRefresh(service, originalConfig) {
  if (!originalConfig || originalConfig._retry) {
    return null;
  }

  const refreshed = await refreshAccessToken();
  if (!refreshed) {
    return null;
  }

  const retryConfig = Object.assign({}, originalConfig, { _retry: true });
  retryConfig.headers = Object.assign({}, originalConfig.headers || {}, {
    'ECAPP-TWXHEADER': getAccessToken()
  });
  return service(retryConfig);
}
